import { render } from "./EquiposProyecto.vue?vue&type=template&id=78e73320&scoped=true"
import script from "./EquiposProyecto.vue?vue&type=script&lang=js"
export * from "./EquiposProyecto.vue?vue&type=script&lang=js"

import "./EquiposProyecto.vue?vue&type=style&index=0&id=78e73320&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e73320"]])

export default __exports__